<template>
	<v-dialog v-model="dialog" max-width="600px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">{{ pageTitle }}</v-app-bar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<div class="mt-2 d-flex">
				<MessageNewDialog
					:message="message"
					:message_templates="message_templates"
					:departments="departments"
					:requirement_types="requirement_types"
				/>
				<MessageTemplateNewDialog @new-message-template="addMessageTemplate($event)" />
			</div>

			<div class="table-container px-2 mt-4">
				<v-row no-gutters v-for="message in messages" :key="'message-id-' + message.id">
					<v-col cols="12" class="py-2">
						<v-card class="hover" @click="showDialog(message)" outlined>
							<div class="message-box">
								<div class="m-top-row">
									<p v-if="message.user && message.user.full_name" class="m-user">
										{{ message.user.full_name }}
									</p>
									<p v-else class="m-user">システム</p>
									<p class="m-date pre-wrap" v-text="message.datetime_ja_2row"></p>
								</div>
								<div class="m-bottom-row">
									<p class="m-title">{{ message.title }}</p>
									<p class="m-flag">{{ message.read_flag_ja }}</p>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			<MessageShowDialog v-if="selectedItem" :item="selectedItem" @close="selectedItem = null" />
		</v-card>
	</v-dialog>
</template>

<script>
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import axios from "axios"

import PaginationModule from "../shared/PaginationModule.vue"
import MessageShowDialog from "./components/MessageShowDialog.vue"
import MessageNewDialog from "./components/MessageNewDialog.vue"
import MessageTemplateNewDialog from "./components/MessageTemplateNewDialog.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		PaginationModule,
		CommonFlame,
		FunctionTitle,
		MessageShowDialog,
		MessageNewDialog,
		MessageTemplateNewDialog,
	},
	data() {
		return {
			dialog: false,
			mainTitle: "お知らせ",
			pageTitle: "メッセージ一覧",
			id: this.$route.params["id"],
			user: null,
			type: "message",
			selectedItem: null,
			message: {
				title: "",
				content: "",
				image: null,
				fileData: {
					type: "",
					fileName: "",
				},
				matter: "",
				user_name: "",
				selectedDepartmentId: "",
				selectedUser: "",
				selectedMessageTemplateId: "",
				selectedRequirementTypeId: "",
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ text: "タイトル", value: "title", width: "200px" },
				{ text: "内容", value: "content", width: "200px" },
				{ text: "時刻", value: "datetime_ja_2row", width: "200px" },
				{ text: "", value: "read_flag_ja", width: "200px" },
			],
			messages: [],
			message_templates: [],
			departments: [],
			requirement_types: [],
			changeFlagMessage: "",
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchMessages()
	},
	methods: {
		openMessageDialog() {
			this.dialog = true
		},
		closeDialog() {
			this.dialog = false
		},
		addMessageTemplate(e) {
			this.message_templates.push(e)
		},
		showDialog(item) {
			// if (!item.url) {
			// 	this.selectedItem = item
			// } else {
			// 	this.$router.push({ path: item.url })
			// }
			this.selectedItem = item
			this.readMessage(item.id)
		},
		readMessage(id) {
			const message = this.messages.find((message) => message.id == id)
			if (message.read_flag_ja == "既読") return
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/messages/${id}`, { headers })
				.then((res) => {
					this.changeFlagMessage = message
					this.changeFlagMessage.read_flag_ja = "既読"
					this.$store.commit("reduceMessageCount")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/messages", {
					params: { page: i, type: this.type },
					headers,
				})
				.then((res) => {
					this.messages = res.data.messages
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		fetchMessages() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/messages`, { headers, params: { type: this.type } })
				.then((res) => {
					this.messages = res.data.messages
					this.pagination = res.data.pagination
					this.message_templates = res.data.message_templates
					this.departments = res.data.departments
					this.requirement_types = res.data.requirement_types
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
<style lang="scss" scoped>
.hover {
	&:hover {
		background-color: #e0e0e0;
	}
}
.message-box {
	width: 100%;
	padding: 8px;
	.m-top-row {
		display: flex;
		justify-content: space-between;
		.m-user {
			font-weight: bold;
			width: 70%;
		}
		.m-date {
			width: 30%;
			font-size: 0.8rem;
			color: gray;
		}
	}
	.m-bottom-row {
		display: flex;
		justify-content: space-between;
		.m-title {
			width: 70%;
		}
		.m-flag {
			width: 30%;
			font-size: 0.8rem;
		}
	}
}
</style>
